<template>
	<div class="flex1" style="height:100%">
		<Title :title="'SOC、平均能耗与度电里程'"></Title>
        <myEchart
			class="myEchart"
            v-if="mileageAndSOCShow"
            :id="'MileageAndSOC'"
            :options="mileageAndSOCOptions" />
    </div>
</template>

<script>
import Title from '../title.vue'
import myEchart from './../charts/echarts'
import { dataInterface } from '@/api/dataInterfaceApi'
import * as echarts from 'echarts5'
export default {
    components: {
		Title,
        myEchart
    },
    data() {
        return {
			// SOC、平均能耗与度电里程
			mileageAndSOCOptions: {},
			mileageAndSOCShow: false,
        }
    },
	mounted() {
		// SOC、平均能耗与度电里程
		this.mileageAndSOC()
	},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log('sf123123123123123123123', data)
			this.dataBase = data
			// SOC、平均能耗与度电里程
			this.mileageAndSOC(data)
		},
		// SOC、平均能耗与度电里程
		mileageAndSOC(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-soc仿真平均能耗和度电里程的关系',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				let data = res.sort(function(a, b) { return (a.soc - b.soc)})
				data = [res.map(item => {
						return [item.soc, item.mileage_per_kwh, item.energy_consumption]
					})]
				this.mileageAndSOCOptions = {
					title: {
						text: '',
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					tooltip: {
						position: 'top',
						formatter: function (params) {
							params = params[0] || {}
							return (
								'SOC：' + params.value[0] + '<br>' +
								'平均能耗：' + params.value[1] + '度/min<br>' +
								'度电里程：' + params.value[2] + 'km/度<br>'
							)
						},
						// trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					xAxis: {
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					yAxis: {
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						},
						scale: true
					},
					series: [{
						name: '平均能耗',
						data: data[0],
						type: 'scatter',
						symbolSize: function (data) {
							return Math.sqrt(data[2]) * 15;
						},
						emphasis: {
							focus: 'series',
							label: {
								show: true,
								formatter: function (param) {
									return param.data[3];
								},
								position: 'top'
							}
						},
						itemStyle: {
							shadowBlur: 10,
							shadowColor: 'rgba(120, 36, 50, 0.5)',
							shadowOffsetY: 5,
							color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
								offset: 0,
								color: '#3865F7'
							},
							{
								offset: 1,
								color: '#3865F7'
							}])
						}
					}]
				}
				this.mileageAndSOCShow = true
			})
			.catch((err) => {
				console.log(err)
			});
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../pcsite/part.scss';
.myEchart {
	height: calc(100% - 60px);
}
</style>